export default {
  // Title
  output: "Output",

  // Buttons
  collapseAll: "Collapse All",
  viewAll: "View All",

  // Message prompts
  copySuccess: "Copy successful!",
};
